"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.timestampJsonReviver = exports.timestampJsonReplacer = void 0;
/* eslint-disable @typescript-eslint/no-explicit-any */
const Timestamp_1 = require("../time/Timestamp");
function timestampJsonReplacer(key, value) {
    if (value instanceof Timestamp_1.Timestamp) {
        return value.toMilliseconds();
    }
    return value;
}
exports.timestampJsonReplacer = timestampJsonReplacer;
function timestampJsonReviver(keys) {
    return (key, value) => {
        if (keys.includes(key)) {
            return new Timestamp_1.Timestamp(value);
        }
        return value;
    };
}
exports.timestampJsonReviver = timestampJsonReviver;
